module.exports = __webpack_public_path__ + "img/logo_plugfest_blue.4f42f013.svg";